import React, { useState, useEffect, useRef } from 'react';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
// import '../styleDrawer.css';
import Snackbar from '@mui/material/Snackbar';

import CustomSnackbar from '../../Optics/Components/CustomSnackbar'; 
import { WriteWifiPointLocation } from '../WriteData/WriteWifiCommunications';
import WifiContainerEdit from './EditContainer/WifiContainerEdit';
import { loadingModelWifiData, loadingTypeWifiData, ValidateAndFormatIp, ValidateAndFormatMac } from '../Data/LoadingDataWifi';
// import CouplingContainerCanton from './ContainerEditCanton/CouplingContainerCanton';
// import FobContainerCanton from './ContainerEditCanton/FobContainerCanton'
// import PonBoxContainerCanton from './ContainerEditCanton/PonBoxContainerCanton';
// import {WriteLineOpticCanton} from '../../WriteData/WriteCantonCommunications'; 
// import { WriteWellHighway, WritePillarHighway, WriteCouplingHighway, WriteFobHighway, WritePonBoxHighway, WritePillarManuallyCanton } from '../../WriteData/WriteHighwayCommunications';   
// import ManholeContainerSummit from '../DrawerEditSummit/ContainerEditSummit/ManholeContainerSummit';   
// import PillarContainerSummit from '../DrawerEditSummit/ContainerEditSummit/PillarContainerSummit';  
// import { ROLE_SENIOR_MASTER } from '../../Constants/ConstantsOptics';


const DrawerEditWifi = ({ openEditCantonDrawer, toggleEditCantonDrawer, toggleWifiMarker, wifiMarker, coordinatesWifiPoint, setCoordinatesWifiPoint, 
         user, highwayTerritory, handleChangeWifiType, selectedWifiType, setSelectedWifiType, wifiPointRefresh, handleStartDrawing,handleStopDrawing }) => {

const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
const [rankComponentData, setRankComponentData] = useState([]);

  //Фоб
  const [isVisibleWifi, setIsVisibleWifi] = useState(false);
  const commentTextWifi = useRef(null);
  const [commentWifi, setCommentWifi] = useState('');
  const [typeWifiData, setTypeWifiData] = useState([]);
  //const [selectedWifiType, setSelectedWifiType] = useState(null);
  const [selectedWifiModelId, setSelectedWifiModelId] = useState();
  const [selectedPolishing, setSelectedPolishing] = useState(3);
  const [areaWifi, setAreaWifi] = useState('');
  const [ipWifiPoint, setIpWifiPoint] = useState('');
  const [macWifiPoint, setMacWifiPoint] = useState('');
  const [uplinkIp, setUplinkIp] = useState('');
  const [uplinkPort, setUplinkPort] = useState('');
  const [wifiLogin, setWifiLogin] = useState('');
  const [wifiPassword, setWifiPassword] = useState('');
  const [controllerIp, setControllerIp] = useState(''); 

  const [dividerData, setDividerData] = useState([]);
  const [wifiModelData, setWifiModel] = useState([]);
  const [polishingData, setPolishingData] = useState([]);
  const [plannedWifi, setPlannedWifi] = useState(0);

const [selectedDividerOptionFob, setSelectedDividerOptionFob] = useState(null);
const [dividerIdFob, setDividerIdFob] = useState("");
  


 const handleAreaWifiChange = (e) => {
    setAreaWifi(e.target.value);
  };

  const handleIpWifiPointChange = (e) => {
    const ip = ValidateAndFormatIp(e.target.value);
    setIpWifiPoint(ip);
  };

   const handleMacWifiPointChange = (e) => {
    const mac = ValidateAndFormatMac(e.target.value);
    setMacWifiPoint(mac);
  };

   const handleUplinkIpChange = (e) => {
    const ip = ValidateAndFormatIp(e.target.value);
    setUplinkIp(ip);
  };

  const handleUplinkPortChange = (e) => {
    setUplinkPort(e.target.value);
  };

  const handleWifiLoginChange = (e) => {
    setWifiLogin(e.target.value);
  };

  const handleWifiPasswordChange = (e) => {
    setWifiPassword(e.target.value);
  };

   const handleControllerChange = (e) => {
    const ip = ValidateAndFormatIp(e.target.value);
    setControllerIp(ip);
  };

  

 

function toggleVisibilityWifi() {
  setIsVisibleWifi(!isVisibleWifi);
}

const handleCommentChangeWifi = (event) => {
  setCommentWifi(event.target.value);
}

// const handleChangeWifiType = (event) => {
//   const selectedType = event.target.value;
//   setSelectedWifiType(selectedType);
// };

const handleChangePolishing = (event) => {
  const selectedPolishing = event.target.value;
  setSelectedPolishing(selectedPolishing);
};

const handleChangeWifiModel = (event) => {
  const selectedModel = event.target.value;
  setSelectedWifiModelId(selectedModel);
};

async function wifiPointSave(event) {
     WriteWifiPointLocation(event, coordinatesWifiPoint, selectedWifiModelId, commentTextWifi, selectedWifiType, areaWifi, showSnackbar, 
      ipWifiPoint, macWifiPoint, uplinkIp, uplinkPort,wifiLogin, wifiPassword, user, setCoordinatesWifiPoint,
      setSelectedWifiModelId,setCommentWifi, setSelectedWifiType, setAreaWifi, setIpWifiPoint, setMacWifiPoint, setUplinkIp, setUplinkPort, setWifiLogin,
      setWifiPassword, wifiMarker, controllerIp, setControllerIp, wifiPointRefresh, plannedWifi, setPlannedWifi );
}
//#endregion



const handleChangeDividerSelectFob = (selectedOption) => {
  if (!selectedOption) {
    setSelectedDividerOptionFob(null);
    setDividerIdFob("");
    return;
  }

  setSelectedDividerOptionFob(selectedOption);
  setDividerIdFob(selectedOption.value);
};

const handlePlannedCheckboxChange = () => {
  setPlannedWifi(plannedWifi === 1 ? 0 : 1);
};


//#endregion

useEffect(() => {
  const fetchData = async () => {
    try {
      const [
        // cableData,
        // cableTypeData,
        // couplingData,
         typeWifiData,
        // ponBoxData,
        // rankCableData,
        // rankComponentData,
        // contractorData,
        // ownerWellData,
        // ownerPillarData,
        // dividerData,
        modelData,
        // polishingData,
        // cassetteData,
      ] = await Promise.all([
        // loadingCableDataComponent(),
        // loadingCableTypeDataComponent(),
        // loadingCouplingDataComponent(),
        // loadingFobDataComponent(),
        // loadingPonBoxDataComponent(),
        // loadingRankCableDataComponent(),
        // loadingRankComponentDataComponent(),
        // loadingContractorDataComponent(),
        // loadingOwnerWellDataComponent(),
        // loadingOwnerPillarDataComponent(),
        loadingTypeWifiData(),
        loadingModelWifiData(),
        // loadingPolishingDataComponent(),
        // loadingCassetteDataComponent(),
      ]);

      // setCableData(cableData);
      // setCableTypeData(cableTypeData);
      // setCouplingData(couplingData);
       setTypeWifiData(typeWifiData);
      // setPonBoxData(ponBoxData);
      // setRankCableData(rankCableData);
      // setRankComponentData(rankComponentData);
      // setContractorData(contractorData);
      // setOwnerWellData(ownerWellData);
      // setOwnerPillarData(ownerPillarData);
      // setDividerData(dividerData);
      setWifiModel(modelData);
      // setPolishingData(polishingData);
      // setCassetteData(cassetteData);
    } catch (error) {
      console.error("Ошибка загрузки данных:", error);
    }
  };

  fetchData();
}, []);
//#region ЗАГРУЗКА ДАННЫХ

 
  return (
    <Drawer
      open={openEditCantonDrawer}
      onClose={toggleEditCantonDrawer(false)}
      PaperProps={{ className: 'drawerBackground hideScrollbar' }}     
    >
      <div className="divTitleDrawer">
            <p className='textTitleWifiDrawer'>Режим внесения</p>
      </div>
      <List  >
        <div className='divBodyDrawer'>
          <p className='textTitleWifiDrawer'>Wi-Fi антенны</p>

             {/* Wi-Fi */}
          <WifiContainerEdit
             toggleVisibilityWifi={toggleVisibilityWifi}
             isVisibleWifi={isVisibleWifi}
             typeWifiData={typeWifiData}
             handleChangeWifiType={handleChangeWifiType}
             selectedWifiType={selectedWifiType}
             commentWifi={commentWifi}
             commentTextWifi={commentTextWifi}
             handleCommentChangeWifi={handleCommentChangeWifi}
             toggleWifiMarker={toggleWifiMarker}
             wifiMarker={wifiMarker}
             wifiPointSave={wifiPointSave}
             rankComponentData={rankComponentData}
             dividerData={dividerData}  
             selectedDividerOptionFob={selectedDividerOptionFob} 
             handleChangeDividerSelectFob={handleChangeDividerSelectFob}
             wifiModelData={wifiModelData}
             selectedWifiModelId={selectedWifiModelId} 
             handleChangeWifiModel={handleChangeWifiModel}
             polishingData={polishingData}
             selectedPolishing={selectedPolishing}
             handleChangePolishing={handleChangePolishing}
             handleAreaWifiChange={handleAreaWifiChange}
             areaWifi={areaWifi}
             handleIpWifiPointChange={handleIpWifiPointChange}
             ipWifiPoint={ipWifiPoint}
             handleMacWifiPointChange={handleMacWifiPointChange}
             macWifiPoint={macWifiPoint}
             handleUplinkIpChange={handleUplinkIpChange}
             uplinkIp={uplinkIp}
             handleUplinkPortChange={handleUplinkPortChange}
             uplinkPort={uplinkPort}
             handleWifiLoginChange={handleWifiLoginChange}
             wifiLogin={wifiLogin}
             handleWifiPasswordChange={handleWifiPasswordChange}
             wifiPassword={wifiPassword} 
             handleControllerChange={handleControllerChange}   
             controllerIp={controllerIp} 
             handleStartDrawing={handleStartDrawing}
             handleStopDrawing={handleStopDrawing}     
             plannedWifi={plannedWifi} 
             handlePlannedCheckboxChange={handlePlannedCheckboxChange} 
          />
     
       </div>

      </List>
       
      {/* Snackbar */}
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        message={snackbarMessage}
        ContentProps={{
          style: {
            backgroundColor: snackbarClass === 'snackbarWarning' ? 'rgb(235, 235, 187)' : 'rgb(193, 255, 174)',
            color: 'black'
          }
        }}
      />

    </Drawer>    
  );
};

export default DrawerEditWifi;